var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-accessible-datepicker',{attrs:{"label":_vm.label,"calendarIcon":require('@/assets/images/calendar/calendar.svg'),"navigate-month-icons":{
    next: require('@/assets/images/calendar/next-arrow.svg'),
    previous: require('@/assets/images/calendar/back-arrow.svg'),
  },"custom-classes":{
    toggleButtonIcon: 'calendar-icon',
    input: 'input-field',
    inputWrapper: 'input-container',
  },"dateFormat":"DD/MM/YYYY","required":_vm.required,"name":_vm.name},on:{"input-change":_vm.inputDate}})}
var staticRenderFns = []

export { render, staticRenderFns }